export default __webpack_public_path__ + "static/media/mouse-active.e00de0c4.svg";